export default "__VITE_ASSET__DpNnE0nx__"